import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import site from '@/config/site.json'
import howToArticles from '@/constants/howToArticles'
import devicePages from '@/constants/devicePages'
import securityArticles from '@/constants/securityArticles'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const canonical = (path) => `${site.domain}${path}`

const homeRoute = ({ path, language, title, keywords, description }) => ({
  path,
  name: `${language}-home`,
  meta: {
    language,
    appname: site.appName,
    title,
    keywords,
    description,
    link: [
      {
        rel: 'canonical',
        href: canonical(path),
      },
    ],
  },
  component: Home,
})

export const constRoutesPc = [
  homeRoute({
    path: '/',
    language: 'en',
    title: site.homeTitle,
    keywords: site.homeKeywords,
    description: site.homeDescription,
  }),
  homeRoute({
    path: '/id/',
    language: 'id',
    title: 'WA GB Terbaru 2026 – Download WhatsApp GB APK',
    keywords: 'wa gb, wa gb terbaru, whatsapp gb, download wa gb, whatsapp gb apk',
    description: 'Download WA GB terbaru 2026 untuk Android. Dapatkan WhatsApp GB APK versi terbaru dengan panduan instalasi, update, backup, dan penggunaan.',
  }),
  homeRoute({
    path: '/es/',
    language: 'es',
    title: 'Descargar GB WhatsApp Actualizado 2026 - Última Versión',
    keywords: 'descargar gb whatsapp, gb whatsapp actualizado, whatsapp gb, ultima version gb whatsapp',
    description: 'Descarga GB WhatsApp actualizado 2026 para Android. Consulta la guía de instalación, funciones, información de actualización y última versión antes de descargar.',
  }),
  homeRoute({
    path: '/br/',
    language: 'br',
    title: 'Baixar WhatsApp GB Atualizado 2026 – Última Versão Android',
    keywords: 'baixar whatsapp gb, whatsapp gb atualizado, whatsapp gb, ultima versao whatsapp gb',
    description: 'Baixe o WhatsApp GB atualizado 2026 para Android. Confira a última versão, como instalar, atualizar e fazer backup do aplicativo.',
  }),
  {
    path: '/how-to/',
    name: 'en-how-to',
    meta: {
      language: 'en',
      appname: site.appName,
      title: 'GB WhatsApp How-To Guides & Fixes | GBWhatsDroid',
      keywords: 'gb whatsapp how to, gb whatsapp guides, install gb whatsapp, fix gb whatsapp',
      description: 'Learn how to install, update, backup, restore, and fix common GB WhatsApp problems with simple step-by-step guides for Android.',
      link: [
        {
          rel: 'canonical',
          href: canonical('/how-to/'),
        },
      ],
    },
    component: () => import('@/views/howTo.vue'),
  },
  ...howToArticles.map((article) => ({
    path: article.path,
    name: `how-to-${article.slug}`,
    meta: {
      language: 'en',
      appname: site.appName,
      title: article.title,
      keywords: article.keywords,
      description: article.description,
      articleSlug: article.slug,
      link: [
        {
          rel: 'canonical',
          href: canonical(article.path),
        },
      ],
    },
    component: () => import('@/views/howToArticle.vue'),
  })),
  ...devicePages.map((devicePage) => ({
    path: devicePage.path,
    name: `device-${devicePage.slug}`,
    meta: {
      language: 'en',
      appname: site.appName,
      title: devicePage.title,
      keywords: devicePage.keywords,
      description: devicePage.description,
      deviceSlug: devicePage.slug,
      link: [
        {
          rel: 'canonical',
          href: canonical(devicePage.path),
        },
      ],
    },
    component: () => import('@/views/devicePage.vue'),
  })),
  {
    path: '/old-versions/',
    alias: '/old-versions',
    name: 'en-old-versions',
    meta: {
      language: 'en',
      appname: site.appName,
      title: 'GB WhatsApp Previous Versions – Older APK Downloads',
      keywords: 'gb whatsapp old versions, gb whatsapp previous version, older gb whatsapp apk',
      description:
        'Check previous GB WhatsApp versions, release details and compatibility notes. Understand the risks of using outdated APK files before installing an older release.',
      link: [{ rel: 'canonical', href: canonical('/old-versions/') }],
    },
    component: () => import('@/views/oldVersions.vue'),
  },
  {
    path: '/security-guide/',
    alias: '/security-guide',
    name: 'en-security-guide',
    meta: {
      language: 'en',
      appname: site.appName,
      title: 'GB WhatsApp Security Guide – Risks, Privacy and Safe Use',
      keywords: 'gb whatsapp security, gb whatsapp privacy, gb whatsapp safe use',
      description:
        'Understand GB WhatsApp security risks, app permissions, privacy concerns and account restrictions. Review practical precautions before installing or using an unofficial WhatsApp app.',
      link: [{ rel: 'canonical', href: canonical('/security-guide/') }],
    },
    component: () => import('@/views/securityGuide.vue'),
  },
  ...securityArticles.map((article) => ({
    path: article.path,
    name: `security-${article.slug}`,
    meta: {
      language: 'en',
      appname: site.appName,
      title: article.title,
      keywords: article.keywords,
      description: article.description,
      articleSlug: article.slug,
      link: [{ rel: 'canonical', href: canonical(article.path) }],
    },
    component: () => import('@/views/securityArticle.vue'),
  })),
  {
    path: '/download-apk/',
    name: 'en-download',
    meta: {
      appname: site.appName,
      title: site.downloadTitle,
      keywords: site.downloadKeywords,
      description: site.downloadDescription,
      link: [
        {
          rel: 'canonical',
          href: canonical(site.downloadPath),
        },
      ],
    },
    component: () => import('@/views/download.vue'),
  },
  {
    path: '/privacy-policy/',
    name: 'en-privacy',
    meta: {
      appname: site.appName,
      title: `Privacy Policy - ${site.siteName}`,
      keywords: `${site.siteName} privacy policy, gbwhatsapp privacy, apk information site`,
      description: `Read the privacy policy for ${site.siteName}. This independent information site explains how visitor data and email inquiries are handled.`,
      link: [
        {
          rel: 'canonical',
          href: canonical('/privacy-policy/'),
        },
      ],
    },
    component: () => import('@/views/privacy.vue'),
  },
  {
    path: '/disclaimer/',
    name: 'en-disclaimer',
    meta: {
      appname: site.appName,
      title: `Disclaimer - ${site.siteName}`,
      keywords: `${site.siteName} disclaimer, gbwhatsapp risk, unofficial mod`,
      description: `Read the disclaimer for ${site.siteName}. This independent site shares GBWhatsApp information and is not affiliated with WhatsApp or the app developer.`,
      link: [
        {
          rel: 'canonical',
          href: canonical('/disclaimer/'),
        },
      ],
    },
    component: () => import('@/views/disclaimer.vue'),
  },
  {
    path: '/about-us/',
    name: 'en-about',
    meta: {
      appname: site.appName,
      title: `About Us - ${site.siteName}`,
      keywords: `${site.siteName} about, gbwhatsapp information site, apk guide`,
      description: `Learn more about ${site.siteName}, an independent information resource for GBWhatsApp APK guides and download instructions.`,
      link: [
        {
          rel: 'canonical',
          href: canonical('/about-us/'),
        },
      ],
    },
    component: () => import('@/views/about.vue'),
  },
  {
    path: '/contact-us/',
    name: 'en-contact',
    meta: {
      appname: site.appName,
      title: `Contact Us - ${site.siteName}`,
      keywords: `${site.siteName} contact, contact email, gbwhatsapp support`,
      description: `Contact ${site.siteName} by email for questions about GBWhatsApp APK information, downloads, or site content.`,
      link: [
        {
          rel: 'canonical',
          href: canonical('/contact-us/'),
        },
      ],
    },
    component: () => import('@/views/contact.vue'),
  },
]

export default function createRouter() {
  return new VueRouter({
    mode: 'history',
    routes: constRoutesPc,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    },
  })
}
